var _dec, _dec2, _dec3, _dec4, _dec5, _dec6, _dec7, _dec8, _dec9, _dec10, _dec11, _dec12, _dec13, _class, _class2, _descriptor, _descriptor2, _descriptor3, _temp;

function _initializerDefineProperty(target, property, descriptor, context) { if (!descriptor) return; Object.defineProperty(target, property, { enumerable: descriptor.enumerable, configurable: descriptor.configurable, writable: descriptor.writable, value: descriptor.initializer ? descriptor.initializer.call(context) : void 0 }); }

function _initializerWarningHelper(descriptor, context) { throw new Error('Decorating class property failed. Please ensure that ' + 'proposal-class-properties is enabled and set to use loose mode. ' + 'To use proposal-class-properties in spec mode with decorators, wait for ' + 'the next major version of decorators in stage 2.'); }

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) { var desc = {}; Object.keys(descriptor).forEach(function (key) { desc[key] = descriptor[key]; }); desc.enumerable = !!desc.enumerable; desc.configurable = !!desc.configurable; if ('value' in desc || desc.initializer) { desc.writable = true; } desc = decorators.slice().reverse().reduce(function (desc, decorator) { return decorator(target, property, desc) || desc; }, desc); if (context && desc.initializer !== void 0) { desc.value = desc.initializer ? desc.initializer.call(context) : void 0; desc.initializer = undefined; } if (desc.initializer === void 0) { Object.defineProperty(target, property, desc); desc = null; } return desc; }

/*!
 * @copyright
 * Copyright(c) 2019 SICK AG
 */
import { Component, Prop, Event, EventEmitter, State, Watch, html, directive, styleMap } from '@sick-davinci/ce-decorators';
import { style } from './Slider.style';
import { AbstractSlider } from './AbstractSlider';
const keyCodeArrowLeft = 37;
const keyCodeArrowUp = 38;
const keyCodeArrowRight = 39;
const keyCodeArrowDown = 40;
const set = new WeakMap(); // WeakSet needs Polyfill, weak map is built in

const pressEventType = 'onpointerdown' in document ? 'pointerdown' : 'ontouchstart' in document ? 'touchstart' : 'mousedown';
const moveEventType = 'onpointerdown' in document ? 'pointermove' : 'ontouchstart' in document ? 'touchmove' : 'mousemove';
const releaseEventType = 'onpointerdown' in document ? 'pointerup' : 'ontouchstart' in document ? 'touchend' : 'mouseup';
const cancelEventType = 'onpointerdown' in document ? 'pointercancel' : 'ontouchstart' in document ? 'touchend' : 'mouseleave';
const pressEventDirective = directive(callback => part => {
  if (set.has(part)) {
    return;
  } else {
    part.element.addEventListener(pressEventType, callback);
    set.set(part, true);
  }
});
/**
 * A slider can be used to choose a value from a specific range.
 * 
 * @example
 * ```html
 * <davinci-slider icon-left="av/volume_mute" value="50" icon-right="av/volume_up"></davinci-slider>
 * ```
 */

export let Slider = (_dec = Component({
  tag: 'davinci-slider',
  style,
  dependencies: [AbstractSlider]
}), _dec2 = Prop({
  reflectAsAttribute: false
}), _dec3 = Reflect.metadata("design:type", Number), _dec4 = Event(), _dec5 = Reflect.metadata("design:type", typeof EventEmitter === "undefined" ? Object : EventEmitter), _dec6 = Event(), _dec7 = Reflect.metadata("design:type", typeof EventEmitter === "undefined" ? Object : EventEmitter), _dec8 = State(), _dec9 = Reflect.metadata("design:type", Number), _dec10 = Watch('min'), _dec11 = Reflect.metadata("design:paramtypes", []), _dec12 = Watch('max'), _dec13 = Reflect.metadata("design:paramtypes", []), _dec(_class = (_class2 = (_temp = class Slider extends AbstractSlider {
  constructor(...args) {
    super(...args);

    _initializerDefineProperty(this, "change", _descriptor, this);

    _initializerDefineProperty(this, "input", _descriptor2, this);

    _initializerDefineProperty(this, "relativeValue", _descriptor3, this);

    this._internalValue = this.min;

    this.focusEvent = () => {
      this._elementKnob.classList.add('focused');
    };

    this.focusOutEvent = () => {
      this.shadowRoot.querySelector('.knob').classList.remove('focused');
    };

    this.keyboardEvent = event => {
      if (event.keyCode === keyCodeArrowUp || event.keyCode === keyCodeArrowRight) {
        this._updateLastPickedKnob(this._increment(), true, true);
      } else if (event.keyCode === keyCodeArrowDown || event.keyCode === keyCodeArrowLeft) {
        this._updateLastPickedKnob(this._decrement(), true, true);
      }
    };

    this.downEvent = event => {
      event.preventDefault();
      event.stopPropagation();

      this._elementKnob.classList.add('pressed');

      document.addEventListener(moveEventType, this.moveEvent);
      document.addEventListener(releaseEventType, this.releaseEvent);
      document.addEventListener(cancelEventType, this.releaseEvent);
    };

    this.moveEvent = event => {
      event.preventDefault();
      event.stopPropagation();

      if (!this.requestAnimationFrame) {
        // debounce events for a smoother experience
        this.requestAnimationFrame = window.requestAnimationFrame(() => {
          const value = this.calcValueFrom(this.getPositionXOf(event));

          this._updateLastPickedKnob(value, true, false);

          this.requestAnimationFrame = null;
        });
      }
    };

    this.releaseEvent = event => {
      event.preventDefault();
      event.stopPropagation();

      if (this.requestAnimationFrame) {
        window.cancelAnimationFrame(this.requestAnimationFrame);
        this.requestAnimationFrame = null;
      }

      const value = this.calcValueFrom(this.getPositionXOf(event));

      this._updateLastPickedKnob(value, false, true);

      document.removeEventListener(moveEventType, this.moveEvent);
      document.removeEventListener(releaseEventType, this.releaseEvent);
      document.removeEventListener(cancelEventType, this.releaseEvent);

      this._elementKnob.classList.remove('pressed');
    };

    this.clickJumpEvent = event => {
      const value = this.calcValueFrom(this.getPositionXOf(event));

      this._updateLastPickedKnob(value, true, true);

      this.downEvent(event);
    };
  }

  get value() {
    return this._internalValue;
  }
  /**
   * Set the value of the slider.
   */


  set value(value) {
    this._adaptValue(value);
  }
  /**
   * Emitted [Number] if the value changes.
   */


  render() {
    return html`
    <div class="slider">
      <div class="slotwrapper">
        <slot></slot>
      </div>
      <div class=icon>${this.renderIcon(this.iconSrcLeft, this.iconLeft)}</div>
      <div class="bar_container" @="${pressEventDirective(this.clickJumpEvent)}" >
        <div class="bar_outer" >
          ${this._drawInnerBar()}
          <div class="touch_container">
            ${this._addKnob0()}
          </div>
        </div>
        ${this.displayLegend()}
      </div>
      <div class=icon>${this.renderIcon(this.iconSrcRight, this.iconRight)}</div>
    </div>
    `;
  }

  componentConnected() {
    this.addEventListener('focus', this.focusEvent);
    this.addEventListener('focusout', this.focusOutEvent);
    this.addEventListener('keydown', this.keyboardEvent);
    this.disabledChangeHandler(this.disabled, this.disabled);
  }

  componentDisconnected() {
    this.removeEventListener('focus', this.focusEvent);
    this.removeEventListener('focusout', this.focusOutEvent);
    this.removeEventListener('keydown', this.keyboardEvent);
  }

  componentFirstRender() {
    this._elementKnob = this.shadowRoot.querySelector('.knob');
  }

  updateMin() {
    if (this._internalValue !== undefined) {
      this._adaptValue(this._internalValue);
    }
  }

  updateMax() {
    if (this._internalValue !== undefined) {
      this._adaptValue(this._internalValue);
    }
  }

  _increment() {
    return this.roundWithTicks(this.validateValue(this._internalValue + this.ticks));
  }

  _decrement() {
    return this.roundWithTicks(this.validateValue(this._internalValue - this.ticks));
  }

  _adaptValue(value) {
    value = this.validateValue(value);
    this._internalValue = value;
    this.relativeValue = this.map(value, this.min, this.max, 0, 100);
  }

  _updateLastPickedKnob(value, emitInput, emitChange) {
    if (emitChange || this.value !== value) {
      this.value = value;

      if (emitInput) {
        this.input.emit(this.value);
      }

      if (emitChange) {
        this.change.emit(this.value);
      }
    }
  }

  _addKnob0() {
    return html`<div class="knob" style="${styleMap({
      left: this.relativeValue + '%'
    })}"
        @="${pressEventDirective(this.downEvent)}" data-id="0"></div>`;
  }

  _drawInnerBar() {
    return html`<div class="bar_inner" style="${styleMap({
      width: this.relativeValue + '%'
    })}"></div>`;
  }

}, _temp), (_applyDecoratedDescriptor(_class2.prototype, "value", [_dec2, _dec3], Object.getOwnPropertyDescriptor(_class2.prototype, "value"), _class2.prototype), _descriptor = _applyDecoratedDescriptor(_class2.prototype, "change", [_dec4, _dec5], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class2.prototype, "input", [_dec6, _dec7], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor3 = _applyDecoratedDescriptor(_class2.prototype, "relativeValue", [_dec8, _dec9], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return this.min;
  }
}), _applyDecoratedDescriptor(_class2.prototype, "updateMin", [_dec10, _dec11], Object.getOwnPropertyDescriptor(_class2.prototype, "updateMin"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "updateMax", [_dec12, _dec13], Object.getOwnPropertyDescriptor(_class2.prototype, "updateMax"), _class2.prototype)), _class2)) || _class);
//# sourceMappingURL=Slider.js.map